import { CodedValueItem } from '../interfaces/coded-value-item.interface';
import { FilterOperatorType } from '../models/filter-operator-type.model';

export const filterOperatorsLabelDictionary = new Map<FilterOperatorType, string>([
  [FilterOperatorType.Eq, 'Igual à'],
  [FilterOperatorType.BiggerThan, 'Maior que'],
  [FilterOperatorType.LessThan, 'Menor que'],
]);

export const numericFilterOperatorsList: CodedValueItem<FilterOperatorType>[] =
  [
    FilterOperatorType.Eq,
    FilterOperatorType.BiggerThan,
    FilterOperatorType.LessThan,
  ].map((value) => {
    return {
      value,
      label: filterOperatorsLabelDictionary.get(value),
    };
  });
